import { Check } from "lucide-react";
import { Reveal } from "../site/Reveal";
import { SectionHeading } from "../site/SectionHeading";
import { PrimaryButton } from "../site/Buttons";

export const BENEFITS = [
  "Exclusive Business & Investment Opportunities",
  "MST Masterclasses & Training",
  "Private Networking Events",
  "Business Growth Resources",
  "Access to MST Financial Services",
  "Priority Support & Consulting",
  "Voting Rights & Governance",
  "Wealth & Legacy Building",
  "Member-to-Member Marketplace",
  "Access to MST Technology & Systems",
];

export const BenefitsChecklist = ({ items = BENEFITS }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5">
    {items.map((b, i) => (
      <Reveal key={b} delay={i * 0.05} y={14} className="flex items-start gap-3.5" data-testid={`benefit-item-${i}`}>
        <span className="w-6 h-6 rounded-full bg-gradient-to-br from-[#006FD6] to-[#009BFF] flex items-center justify-center shrink-0 mt-0.5 shadow-[0_2px_8px_rgba(0,111,214,0.4)]">
          <Check size={13} strokeWidth={3} className="text-white" />
        </span>
        <span className="text-[15px] font-semibold text-[#041525] leading-relaxed">{b}</span>
      </Reveal>
    ))}
  </div>
);

export const BenefitsSection = () => (
  <section data-testid="benefits-section" className="bg-gradient-to-b from-[#F6F8FA] via-white to-[#F6F8FA] py-28 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center">
      <div>
        <SectionHeading
          chapter="03"
          label="Member Benefits"
          title={<>More Than a Membership.<br />It&rsquo;s an Ecosystem.</>}
        />
        <Reveal delay={0.15}>
          <p className="mt-8 text-[#6B7280] leading-[1.85] max-w-lg">
            MST members gain access to a private ecosystem designed to support business growth,
            wealth creation, collaboration, education, and personal development.
          </p>
          <div className="mt-10">
            <PrimaryButton to="/membership" data-testid="view-membership-btn">View Membership</PrimaryButton>
          </div>
        </Reveal>
      </div>
      <BenefitsChecklist />
    </div>
  </section>
);
